import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import translationDe from './locales/de/translationDe.json'
import translationEn from './locales/en/translationEn.json'
import translationFr from './locales/fr/translationFr.json'
import translationIt from './locales/it/translationIt.json'
import translationEs from './locales/es/translationEs.json'
import translationRu from './locales/ru/translationRu.json'
import translationCn from './locales/cn/translationCn.json'
import translationJa from './locales/ja/translationJa.json'
import translationKo from './locales/ko/translationKo.json'
import translationPl from './locales/pl/translationPl.json'

import LanguageDetector from 'i18next-browser-languagedetector'
import FlagAt from './assets/images/flags/flag-at.svg' //3:2
import FlagEn from './assets/images/flags/flag-en.svg'
import FlagEs from './assets/images/flags/flag-es.svg'
import FlagIt from './assets/images/flags/flag-it.svg'
import FlagFr from './assets/images/flags/flag-fr.svg'
import FlagRu from './assets/images/flags/flag-ru.svg'
import FlagCn from './assets/images/flags/flag-cn.svg'
import FlagJa from './assets/images/flags/flag-ja.svg'
import FlagKo from './assets/images/flags/flag-ko.svg'
import FlagPl from './assets/images/flags/flag-pl.svg'

export const languages = ['de', 'en', 'fr', 'es', 'it', 'pl', 'ja', 'ko', 'cn', 'ru']
export const flags = {'de': FlagAt, 'en': FlagEn, 'it': FlagIt, 'es': FlagEs, 'fr': FlagFr, 'pl': FlagPl, 'ja': FlagJa, 'ko': FlagKo, 'cn': FlagCn, 'ru': FlagRu}
export const i18NextKeyForLocalStorage = 'i18nextLng'

const resources = {
  de: {
    translation: translationDe
  },
  en: {
    translation: translationEn
  },
  fr: {
    translation: translationFr
  },
  it: {
    translation: translationIt
  },
  es: {
    translation: translationEs
  },
  ru: {
    translation: translationRu
  },
  pl: {
    translation: translationPl
  },
  ja: {
    translation: translationJa
  },
  ko: {
    translation: translationKo
  },
  cn: {
    translation: translationCn
  }
}

i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  // want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
  /*.use(Backend)*/
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    resources,
    detection: {
      order: ['path', 'cookie', 'localStorage', 'navigator', 'htmlTag'] // we could configure path detection, but it works as it is.
    },

    // lng: 'de', // hardcoded language
    fallbackLng: 'en',
    supportedLngs: languages,
    load: 'languageOnly',
    debug: false,
    interpolation: {
      escapeValue: false // not needed for react as it escapes by default
    },

    // keys or params to lookup language from
    lowerCaseLng: true,
    lookupCookie: 'i18next',
    lookupLocalStorage: 'i18nextLng',
    // cache user language on
    caches: ['localStorage', 'cookie'],
    excludeCacheFor: ['cimode'], // cimode is mode where only label keys are shown
    // optional expire and domain for set cookie
    cookieMinutes: 365*24*60, // one year – if not set it becomes a session cookie
    // cookieDomain: 'myDomain', // defaults to the current hosts domain
    // optional set cookie options, reference:[MDN Set-Cookie docs](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Set-Cookie)
    cookieOptions: { path: '/', sameSite: 'strict' }
  })

export default i18n
